module.exports = '<svg width="24" height="32" viewBox="0 0 24 32"><path d="M0 30.252V1.748C0 .16 2.004-.448 3.112.356l19.912 14.18c1.1.804 1.376 2.124.272 2.928L2.972 31.644c-1.1.812-2.972.188-2.972-1.392z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/right-1.js
// module id = 1377
// module chunks = 14